/** Pure helper for reading server-sent events; kept free of browser imports so it can be unit tested. */

/**
 * Split a growing text buffer into complete events plus the unfinished rest.
 * @param {string} buffer
 * @returns {{ events: object[], rest: string }}
 */
export const parseSseChunk = (buffer) => {
  const parts = String(buffer).split('\n\n')
  const rest = parts.pop() // may be half an event
  const events = []
  for (const part of parts) {
    const line = part.split('\n').find((l) => l.startsWith('data:'))
    if (!line) continue
    try { events.push(JSON.parse(line.slice(5).trim())) } catch { /* a damaged event is skipped, never fatal */ }
  }
  return { events, rest }
}
